import { Children, FC, ReactElement, cloneElement, useContext, useRef } from 'react';
import { DraggableContext } from '.';

export interface IDragHandle {
    children?: React.ReactNode;
}

export const DragTouchHandle: FC<IDragHandle> = ({ children }) => {
    const ref = useRef<HTMLElement>(null);
    const manager = useContext(DraggableContext);

    type DragTouchChildProps = React.HTMLAttributes<HTMLElement> & {
        ref?: React.Ref<HTMLElement>;
        style?: React.CSSProperties;
    };

    const onTouchStart = (ev: React.TouchEvent<HTMLElement>) => {
        manager.onTouchStart(ev.nativeEvent);
    };

    const child = Children.only(children) as ReactElement<DragTouchChildProps>;
    const setNodeRef = (node: HTMLElement | null) => {
        ref.current = node;

        const childRef = child.props.ref;
        if (!childRef) {
            return;
        }

        if (typeof childRef === 'function') {
            childRef(node);
        } else {
            (childRef as React.RefObject<HTMLElement | null>).current = node;
        }
    };

    return cloneElement(child, {
        ref: setNodeRef,
        onTouchStart,
        style: {
            ...child.props.style,
            userSelect: 'none',
            touchAction: 'none'
        }
    });
};
